


/**
 * Error component to display an error message centered on the page.
 *
 * @param {Object} props - Component props.
 * @param {string} [props.message] - Optional custom error message to display.
 * @returns {JSX.Element} The rendered error message component.
 */
export default function Error({ message }) {

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "80vh",
      }}
    >
      {message ? message : "There was an error loading your page, this error has been recorded"}
    </div>
  );
}
